// ─── DESIGN PALETTE ──────────────────────────────────────────────────────────
const C = {
  bg:     '#F8F9FA',
  ink:    '#0A192F',
  gold:   '#D4AF37',
  muted:  '#8A97A8',
  border: '#E8EAED',
  dark:   '#0F172A',
  navy:   '#0A192F',
  glass:  'rgba(15,23,42,0.72)',
};

export default C;
